export interface FileModel {
  Id?: string;
  Folder?: string;
  Name?: string;
  DownloadUri?: string;
  FileSize?: number;
  Type: string;
}

export interface ClientOnlyFileModel extends FileModel {
  uid: string;
  file?: File;
  status?: FileAttachmentStatus;
}

export enum FileAttachmentStatus {
  pending = 'pending',
  complete = 'complete',
  error = 'error',
  uploading = 'uploading',
  deleting = 'deleting',
}

export type FileData = Map<string, ClientOnlyFileModel>;
